import { mapGetters } from "vuex";

export default {
    data() {
        return {
            activeFilters: [],
            scrollEdge: {
                left: true,
                right: false
            }
        };
    },
    watch: {
        activeFilters() {
            this.$store.dispatch("filterThesaurus", this.activeFilters);
        }
    },
    computed: {
        ...mapGetters(["getFilters"])
    },
    methods: {
        getFilterTitle(filterName) {
            switch (filterName) {
                case "commonFilter":
                    return this.$t("thesaurusAltTextCommonFilter");
                case "antonymFilter":
                    return this.$t("thesaurusAltTextAntonymsFilter");
                case "uniqueFilter":
                    return this.$t("thesaurusAltTextUniqueFilter");
            }
        },
        trackPartOfSpeech(pos) {
            this.$ga.event({
                eventCategory: "Part of speech filter",
                eventAction: "Select part of speech"
            });
        },
        trackAdditionalFilter(name) {
            switch (name) {
                case "commonFilter":
                    this.$ga.event({
                        eventCategory: "Common words filter",
                        eventAction: "Show common words"
                    });
                    break;
                case "antonymFilter":
                    this.$ga.event({
                        eventCategory: "Antonym filter",
                        eventAction: "Show antonym words"
                    });
                    break;
                case "uniqueFilter":
                    this.$ga.event({
                        eventCategory: "Unique words filter",
                        eventAction: "Show unique words"
                    });
                    break;
            }
        },
        onScroll(event) {
            let el = event.target;
            this.scrollEdge.left = el.scrollLeft === 0;
            this.scrollEdge.right = el.scrollLeft === el.scrollWidth - el.clientWidth;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SynonymFilter/SynonymFilter.js